import { render, staticRenderFns } from "./MiddlewareOAuthGoogle.vue?vue&type=template&id=44b27b91&scoped=true"
import script from "./MiddlewareOAuthGoogle.vue?vue&type=script&lang=ts"
export * from "./MiddlewareOAuthGoogle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b27b91",
  null
  
)

export default component.exports